<template>
  <div id="app">
    <section>
      <div class="page-title">智能锁安装指引</div>
      <div class="guide">
        <!-- https://a.app.qq.com/o/simple.jsp?pkgname=com.eques.doorbell -->
        <!-- https://a.app.qq.com/o/simple.jsp?pkgname=com.eques.doorbell.nobrand -->
        <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.eques.doorbell" class="mint-cell guide1">
          <span class="mint-cell-mask"></span>
          <div class="mint-cell-left"></div>
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title">
              <div style="margin-top:23px "><i class="indexicon icon-toast"></i><img src="../assets/app.png">
                <span>中国大陆地区APP下载</span>
              </div>
            </div>
            <div class="mint-cell-value is-link"><span></span></div>
            <i class="mint-cell-allow-right"></i>
          </div>
          <div class="mint-cell-right"></div>
        </a>

        <!--      <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.eques.doorbell" class="mint-cell"><span-->
        <!--        class="mint-cell-mask"></span>-->
        <!--        <div class="mint-cell-left"></div>-->
        <!--        <div class="mint-cell-wrapper">-->
        <!--          <div class="mint-cell-title">-->
        <!--            &lt;!&ndash;&ndash;&gt;-->
        <!--            <div><i class="indexicon icon-toast"></i> <span>苹果手机下载</span></div>-->
        <!--          </div>-->
        <!--          <div class="mint-cell-value is-link"><span></span></div>-->
        <!--          <i class="mint-cell-allow-right"></i>-->
        <!--        </div>-->
        <!--        <div class="mint-cell-right"></div>-->
        <!--      </a>-->
        <div class="guide1">
          <router-link to="/bind" class="mint-cell" style="border-radius:10px ;height: 70px;background-color: #F5F5F5 ">
            <span class="mint-cell-mask"></span>
            <div class="mint-cell-left"></div>
            <div class="mint-cell-wrapper">
              <div class="mint-cell-title">
                <!---->
                <div style="margin-top:23px "><i class="indexicon icon-toast"></i><img src="../assets/guide.png">
                  <span>可视智能锁使用指南</span>
                </div>
              </div>
              <div class="mint-cell-value is-link"><span></span></div>
              <i class="mint-cell-allow-right"></i>
            </div>
            <div class="mint-cell-right"></div>

          </router-link>
        </div>

        <div class="guide1">
          <router-link to="/intercom" class="mint-cell"
            style="border-radius:10px ;height: 70px;background-color: #F5F5F5 ">
            <span class="mint-cell-mask"></span>
            <div class="mint-cell-left"></div>
            <div class="mint-cell-wrapper">
              <div class="mint-cell-title">
                <!---->
                <div style="margin-top:23px "><i class="indexicon icon-toast"></i><img src="../assets/guide.png">
                  <span>可视对讲智能锁使用指南</span>
                </div>
              </div>
              <div class="mint-cell-value is-link"><span></span></div>
              <i class="mint-cell-allow-right"></i>
            </div>
            <div class="mint-cell-right"></div>

          </router-link>
        </div>

        <div class="guide1">
          <router-link to="/commonproblem" class="mint-cell "
            style="border-radius:10px ;height: 70px;background-color: #F5F5F5 ">
            <span class="mint-cell-mask"></span>
            <div class="mint-cell-left"></div>
            <div class="mint-cell-wrapper">
              <div class="mint-cell-title">
                <!---->
                <div style="margin-top:23px "><i class="indexicon icon-toast"></i><img src="../assets/qa.png">
                  <span>常见问题</span>
                </div>
              </div>
              <div class="mint-cell-value is-link"><span></span></div>
              <i class="mint-cell-allow-right"></i>
            </div>
            <div class="mint-cell-right"></div>

          </router-link>
        </div>
        <a href="https://market.android.com/details?id=com.eques.doorbell" class="mint-cell guide1">
          <span class="mint-cell-mask"></span>
          <div class="mint-cell-left"></div>
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title">
              <div style="margin-top:23px "><i class="indexicon icon-toast"></i><img src="../assets/down.png">
                <span style="font-size: 0.87rem;">Non-Chinese Mainland Download</span>
              </div>
            </div>
            <div class="mint-cell-value is-link"><span></span></div>
            <i class="mint-cell-allow-right"></i>
          </div>
          <div class="mint-cell-right"></div>
        </a>

      </div>
    </section>
  </div>

</template>

<script>
  /* eslint-disable */
  export default {
    name: 'home',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    // mounted(){
    //   console.log("onload")
    //   var canvas = this.$refs.myCanvas;
    //   var ctx = canvas.getContext('2d');
    //   var image = new Image();
    //   image.src =
    //   	"https://p3-sign.toutiaoimg.com/tos-cn-i-qvj2lq49k0/1b47dc3e8608470cba6ef1023541376c~noop.image?_iz=58558&from=article.pc_detail&x-expires=1668584618&x-signature=32VVs0YmBgzkBuJQndn901f2OGQ%3D";
    //   image.onload = () => {
    //   	ctx.drawImage(image, 0, 0,320,480);
    //   	// ctx.drawImage();
    //   }

    // },
    // methods: {


    //   downApp () {
    //     let ua = navigator.userAgent.toLowerCase()
    //
    //     let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
    //
    //     let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    //     if (isWeixinBrowser()) {
    //       this.$router.push({
    //         path: '/product'
    //       })
    //     } else {
    //       if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //         //Ios
    //         window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.eques.doorbell'
    //       } else if (/(Android)/i.test(navigator.userAgent)) {
    //         //Android终端
    //         window.location = 'http://eques.oss-cn-hangzhou.aliyuncs.com/DingDong/DingDong_android_CN_B_V3.03.88.apk'
    //       }
    //     }
    //
    //     function isWeixinBrowser () {
    //       return (/micromessenger/.test(ua)) ? true : false
    //     }
    //
    //   }
    // }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .indexicon {
    font-size: 22px;
    color: #26a2ff;
    display: inline-block;
    width: 30px;
    vertical-align: middle;
  }

  .page-title {
    font-weight: 900;
    font-size: 20px;
    margin: 20px auto;
    text-align: center;
    display: block;
    line-height: 1;
    left: 118px;
    margin-top: 104px;
    font-family: blod 黑体;

  }

  .mint-cell-wrapper {
    background-image: none !important
  }

  .guide {
    margin-top: 30px;
  }


  .guide1 {
    margin-top: 20px;
    margin-left: 5%;
    width: 90%;
    height: 70px;
    border-radius: 10px;
    background-color: #F5F5F5;
    /*-webkit-box-shadow: #666 0px 0px 3px;*/
    /*-moz-box-shadow: #666 0px 0px 3px;*/
    /*box-shadow: #666 0px 0px 3px;*/

  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue